import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';
import Memo from './class';

export const actions = {
  REQUEST: 'Dora/project-memos/REQUEST',
  RECEIVE: 'Dora/project-memos/SUCCESS',
  FAIL: 'Dora/project-memos/FAIL',
  UPDATE_THANKS_RECEIVED_FROM: 'Dora/project-memos/UPDATE_THANKS_RECEIVED_FROM',
};

export default makeReducer({
  actions,
  handlers: {
    [actions.UPDATE_THANKS_RECEIVED_FROM]: (state, action) => ({
      ...state,
      data: state.data.map((memo) => {
        if (memo._id === action.memoId) {
          return { ...memo, thanksReceivedFrom: action.thanksReceivedFrom };
        }

        return memo;
      }),
    }),
  },
});

const actionCreators = makeActionCreators({
  reducerName: 'projectMemos',
  actions,
  requestDataCall: (store, params) => {
    const query = [];
    if (params.project) {
      query.push(`project=${params.project}`);
    }
    if (params.goal) {
      query.push(`goal=${params.goal}`);
    }

    return API.get(`memos?${query.join('&')}`).then((memos) =>
      memos.map((memo) => new Memo(memo))
    );
  },
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;
export const updateThanksReceivedFrom = (memoId, thanksReceivedFrom) => ({
  type: actions.UPDATE_THANKS_RECEIVED_FROM,
  memoId,
  thanksReceivedFrom,
});



// WEBPACK FOOTER //
// ./src/memos/duck.js